export const PASSWORD_CHANGE_REASON = Object.freeze({
  NONE: "NONE",
  RESET_PASSWORD: "RESET_PASSWORD",
  EXPIRED: "EXPIRED",
});

const isValidDate = (date) => date instanceof Date && !Number.isNaN(date.getTime());

/**
 * Central rule (shared across Login/Home/guards/OTP):
 * Force password change only if:
 *  - backend says `resetPassword === true`, OR
 *  - `dateExpiration` is present AND already in the past (<= now)
 *
 * `dateExpiration == null` must NOT force by itself.
 * `lastPasswordChangeDate` must NOT be used alone for the decision.
 */
export const evaluatePasswordChangeRequirement = (sessionUser, now = new Date()) => {
  const safeNow = now instanceof Date ? now : new Date(now);

  const resetPassword = sessionUser?.resetPassword === true;
  const dateExpirationRaw = sessionUser?.dateExpiration;
  const lastPasswordChangeDate = sessionUser?.lastPasswordChangeDate;

  let expirationDate = null;
  let expired = false;

  if (dateExpirationRaw !== null && dateExpirationRaw !== undefined && dateExpirationRaw !== "") {
    const parsed = new Date(dateExpirationRaw);
    if (isValidDate(parsed) && isValidDate(safeNow)) {
      expirationDate = parsed;
      expired = parsed.getTime() <= safeNow.getTime();
    }
  }

  const shouldForce = resetPassword || expired;
  const reason = resetPassword
    ? PASSWORD_CHANGE_REASON.RESET_PASSWORD
    : expired
      ? PASSWORD_CHANGE_REASON.EXPIRED
      : PASSWORD_CHANGE_REASON.NONE;

  if (process.env.NODE_ENV !== "production") {
    // Temporary debug logs requested (remove once validated)
    // console.info("[password-change] decision", {
    //   resetPassword,
    //   dateExpiration: dateExpirationRaw,
    //   lastPasswordChangeDate,
    //   now: isValidDate(safeNow) ? safeNow.toISOString() : safeNow,
    //   expirationDate: isValidDate(expirationDate) ? expirationDate.toISOString() : expirationDate,
    //   reason,
    //   shouldForce,
    // });
  }

  return {
    shouldForce,
    reason,
    resetPassword,
    dateExpiration: dateExpirationRaw,
    lastPasswordChangeDate,
    now: safeNow,
    expirationDate,
  };
};

